import { IconFn, IconSvg } from "../createIcon";

export const SearchIcon: IconFn = ({ color = "#655C94", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 21, height: 22 }} {...props}>
    <path
      d="m20 20.5-4.486-4.494L20 20.5ZM18 10a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0v0Z"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
    />
  </IconSvg>
);
